import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Gallery, GalleryItem, ImageItem, ImageSize, ThumbnailsPosition, VideoItem } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ConfigService } from 'src/app/core/service/config.service';
import { AuctionModal } from 'src/app/features/bidders/core/modal/auctions';
import { ApiAuctionsService } from 'src/app/features/bidders/core/service/api-auctions.service';
import { environment } from 'src/environments/environment';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { SocketUpates } from 'src/app/features/rooms/core/modal/socketUpdates';
import { Subscription } from 'rxjs';
import { socketActions } from 'src/app/features/rooms/core/enums/socketActions';

@Component({
  selector: 'app-item-info',
  templateUrl: './item-info.component.html',
  styles: [
  ]
})
export class ItemInfoComponent implements OnInit {
  @Input() auctionData: AuctionModal | any; // when call this from component
  @Input() itemId: string = ''; //When open item in side sheet
  @Input() auctionStatus: any;
  @Input() noAuth = false;
  detailsItem: any;
  slider: any;
  MediaList: any;
  safeUrl: any;
  subscriptions: Subscription[] = [];
  reloadJoinedList: number = 0;
  vedioStreamList: any[] = [];
  LoadingStream: boolean = false;
  showRecordStream: boolean = false;
  customOptions: OwlOptions = {
    rtl: localStorage.getItem("language") == "ar" ? true : false,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    center: false,
    navSpeed: 700,
    // navText: ['', ''],
    margin: 25,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 4
      },
      740: {
        items: 4
      },
      940: {
        items: 4
      },
      1200: {
        items: 6
      }
    },
    nav: false
  }


  loading: boolean = false;
  constructor(public gallery: Gallery,
    public lightbox: Lightbox,
    private sanitizer: DomSanitizer,
    public _config: ConfigService,
    public _auctionApi: ApiAuctionsService,
    private _socket: SocketService) {

  }

  ngOnInit(): void {
    // if (!this.auctionData && this.itemId) {
    //   this.GetItemDetails(this.itemId);
    // }
    const unsafeUrl = 'javascript:alert("XSS attack!");';
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.auctionData.link_streaming);
    this.showRecordStream = this._config.getAuthUserInfo()?.user?.role_code != 'General' ? true : false;



    // To detect if any updated happend in this auction
    this.subscriptions.push(
      this._socket.getDataStream<string>(`room-or-auction-updated`)
        .subscribe(message => {
          let data: SocketUpates = message.data;
          if (data.auctionId == (this.itemId || this.auctionData.id) && !data.isChangeOnRoom && (data.typeChanges === socketActions.JOINED || data.typeChanges === socketActions.LEAVED)) {
            this.reloadJoinedList = new Date().getTime();
          }

        })
    )



  }

  ngOnChanges(changes: any): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes) {
      this.detailsItem = this.auctionData.details;
      this.slider = this.auctionData.files.filter((file: any) => file.isMain == 0);
      this.MediaConfig()
      if (this.auctionData?.stream_id) {
        this.GetVedioSteam();

      }

    }
    if ('auctionStatus' in changes) {
      this.auctionData.type = this.auctionStatus;
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }



  MediaConfig() {

    /** Basic Gallery Example */

    // Creat gallery items
    this.MediaList = this.slider.map((item: any) => {
      if (item.type === 'video') {
        return new VideoItem({ src: item.path, thumb: "assets/images/defualt_thumbnail.png", controls: true, autoplay: false, preload: 'auto' });
      } else {
        return new ImageItem({ src: item.path, thumb: item.path });
      }
    });


    /** Lightbox Example */

    // Get a lightbox gallery ref
    const galleryId = 'lightbox';
    const galleryRef = this.gallery.ref(galleryId);
    // Add custom gallery config to the lightbox (optional)
    galleryRef.setConfig({
      imageSize: 'cover',       // Keeps portrait images and videos properly scaled
      autoPlay: false,            // Prevents auto-advancing slides during video playback
      loop: true,                 // Infinite scrolling looping
      counter: true,              // Displays the slide index number (e.g., 1 / 5)

      // 📸 ENABLE THUMBNAILS AT THE BOTTOM
      thumb: true,                // 👈 Re-enables the thumbnail row
      thumbPosition: 'bottom',    // 👈 Forces the thumbnail panel below the media view
      thumbWidth: 100,            // (Optional) Sets the width of each thumbnail in pixels
      thumbHeight: 75,            // (Optional) Sets the height of each thumbnail in pixels

      // Smooth navigation transitions config
      slidingEase: {
        x1: 0.25,
        y1: 0.46,
        x2: 0.45,
        y2: 0.94
      },
      slidingDuration: 350
    });

    // Load items into the lightbox gallery ref
    galleryRef.load(this.MediaList);
  }



  GetVedioSteam() {

    this.LoadingStream = true;
    this._auctionApi.getAuctionVedioStreamList(this.auctionData?.stream_id).subscribe({
      next: (res: any) => {
        this.LoadingStream = false;
        this.vedioStreamList = res.data
        this.vedioStreamList.forEach((item: any) => {
          item.filePath = `${environment.streamUrl}/${item.filePath}?&token=${this.auctionData?.stream_play_token}`;
          item.thumb = item.filePath;
          item.src = item.filePath;
        });

      },
      error: (error: any) => {
        this.LoadingStream = false;
        this._config.showErrors(error);

      }

    })
  }

  GetItemDetails(id: any) {
    this.loading = true;
    this._auctionApi.getOneAuction(id).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.auctionData = res.data;
      },
      error: (error: any) => {
        this.loading = false;
        this._config.showErrors(error);
      },
    })
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions.forEach((subscription) => { subscription.unsubscribe(); });
  }

}
